import React, {Fragment} from "react";
import {useContent} from "../../customHooks/useContent";
import content from "../../content/admission.json";
import {PageHeader} from "../PageHeader";
import ReactHtmlParser from 'react-html-parser';
import {generateRandomKey} from "../../utils/generateRandomKey";

export const Admission = () => {
    const {subtitle, target, fee, date, contact} = useContent(content);

    return (
        <Fragment>
            <PageHeader subtitle={subtitle} imageClass="header-school-admissions"/>
            <main>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{target?.header}</h2>
                            <p>{target?.paragraph}</p>
                        </section>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{fee?.header}</h2>
                            <p>{fee?.price}</p>
                            <p>{fee?.covers.title}:</p>
                            <ul>
                                {fee?.covers?.list.map(item => <li key={generateRandomKey()}>{item}</li>)}
                            </ul>
                        </section>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{date?.header}</h2>
                            <p>{date?.paragraph}</p>
                        </section>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{contact?.header}</h2>
                            <p>{contact?.name}<br />
                                {ReactHtmlParser(contact?.email)}<br />
                                {contact?.skype}</p>
                        </section>
                    </div>
                </div>
            </main>
        </Fragment>
    )
};
